import { IImage, IVideo } from '@belong/types';

export const multipleSources = (image?: IImage, videoId?: string, video?: IVideo): boolean =>
  Boolean(image ? videoId || video : videoId && video);
